import 'toastr/toastr.scss';
import * as toastr from 'toastr';

declare global
{
    interface WindowEventMap
    {
        'ui:messenger:show-message': CustomEvent<Message>;
    }
}

class Messenger
{
    public success(message: string): void {
        toastr.success(message);
    }

    public error(message: string): void {
        toastr.error(message);
    }

    public info(message: string): void {
        toastr.info(message);
    }

    public warning(message: string): void {
        toastr.warning(message);
    }

    public danger(message: string): void {
        toastr.error(message); // 'danger' is treated as an error in toastr
    }
}

window.addEventListener('ui:messenger:show-message', (event: CustomEvent) => {
    const data = event.detail;
    if (!isMessage(data)) {
        console.error('Invalid message data:', data);
        return;
    }
    switch (data.type) {
        case 'success':
            messenger.success(data.message);
            break;
        case 'error':
            messenger.error(data.message);
            break;
        case 'info':
            messenger.info(data.message);
            break;
        case 'warning':
            messenger.warning(data.message);
            break;
        case 'danger':
            messenger.danger(data.message);
            break;
        default:
            console.error('Unknown message type:', data.type);
    }
});

type Message = {
    message: string;
    type: 'success' | 'error' | 'info' | 'warning' | 'danger';
}

const isMessage = (data: any): data is Message => {
    return typeof data === 'object'
        && typeof data.message === 'string'
        && ['success', 'error', 'info', 'warning', 'danger'].includes(data.type);
}

export const messenger = new Messenger();
